import { trigger, state, style, transition, animate } from '@angular/animations';
import { AfterViewInit, Component, OnInit, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { truncateSync } from 'fs';
import { ToastrService } from 'ngx-toastr';
import { WebcamInitError, WebcamUtil, WebcamImage } from 'ngx-webcam';
import { Subject, Observable } from 'rxjs';
import { AuthService } from 'src/app/core/auth/auth.service';
import { CustomerFilterLanguage } from 'src/app/core/class/customer-filter-language';
import { Message } from 'src/app/core/class/message';
import { EnterpriseTypes } from 'src/app/core/constants/enterprise-type';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { CommonService } from 'src/app/core/services/common.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { EnterpriseService } from 'src/app/core/services/enterprise.service';
import { KycService } from 'src/app/core/services/kyc.service';
import { AlertEkycComponent } from 'src/app/shared/components/alert-ekyc/alert-ekyc.component';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { ConfirmCancelComponent } from '../confirm-cancel/confirm-cancel.component';
import { OtpIdentifyComponent } from './otp-identify/otp-identify.component';
import { RefuseIdentifyComponent } from './refuse-identify/refuse-identify.component';
import { ErrorCode } from 'src/app/core/constants/error-code';
import {ChangePasswordComponent} from '../../../shared/components/change-password/change-password.component';
import {DeviceDetectorService} from 'ngx-device-detector';
import {VerifyEnterpriceDialogComponent} from '../../../shared/components/verify-enterprice-dialog/verify-enterprice-dialog.component';
import { format } from 'date-fns';

@Component({
  selector: 'app-kyc-customer-identify',
  templateUrl: './kyc-customer-identify.component.html',
  styleUrls: ['./kyc-customer-identify.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('void', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
      state('*', style({ height: '*', visibility: 'visible' })),
      transition('void <=> *', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  entryComponents: [VerifyEnterpriceDialogComponent]
})
export class KycCustomerIdentifyComponent extends BaseComponent implements OnInit, AfterViewInit {

  @ViewChildren('focus') focus;
  isEnoughImage: boolean = false
  isSubmitConfirm: boolean = false;
  hasNote: boolean = true;
  title: string = '';
  personalId = EnterpriseTypes.PERSONAL;
  certificateType: any;
  certificate: any;
  type: any;
  readonly = true
  representativeCertificateName: any;
  representativeCertificateType: any;
  representativeCertificate: any;
  enterpriseId: string;
  customer = {
    id: null,
    enterpriseName: '',
    enterpriseId: localStorage.getItem('enterpriseId'),
    primaryEmail: null,
    customerType: 0,
    name: '',
    status: null,
    certificateId: null,
    certificateNo: '',
    issuedDate: null,
    issuedAt: '',
    taxCode: '',
    representative: '',
    position: '',
    representativeCertificateId: null,
    representativeCertificateNo: '',
    representativeIssuedDate: '',
    representativeIssuedAt: '',
    birthday: null,
    sex: null,
    accountNumber: '',
    accountName: '',
    bankName: '',
    bankBranch: '',
    phone: '',
    fax: '',
    email: '',
    address: '',
    cityId: null,
    wardId: null,
    districtId: null,
    attachments: [],
    adminUser: '',
    hasPermission: true,
    attachmentImages: [],
    identifyStatus: null,
    identifyRejectReason: '',
    issuedDateDisplay: '',
    representativeIssuedDateDisplay: '',
    birthdayDisplay: ''
  };
  customerType: any;
  enterpriseType: [{
    id: number,
    name: '',
    langs: []
  }];
  addresses = {
    cityName: '',
    districtName: '',
    wardName: ''
  };
  defaultAddress = {
    cityId: null,
    districtId: null,
    wardId: 1,
    enterpriseId: null,
    address: ''
  };

  cities: { id: number, name: '', description: '' }[];
  districts: { id: number, cityId: number, name: '', description: '' }[];
  selectedDistricts: { id: number, cityId: number, name: '', description: '' }[];
  wards: { id: number, districtId: number, name: '', description: '' }[];
  selectWards: { id: number, districtId: number, name: '', description: '' }[];
  // enterpriseName: string = '';

  pdfSrc: string;
  zoomLevel = 100;
  widthRectangle = 300;
  heightRectangle = 136;
  pageCurrent = 1;
  imagePreviewHeight: number;
  imagePreviewWidth: number;
  public language: string;
  public isShowSidebarButton = true;
  public mediaBreakpoint: any;
  public SCREEN_SIZE = SCREEN_SIZE;
  checkAgree = false;
  checkCertificateType = false;
  checkPassport = false;
  private tenantId: string;
  private hashKey: string;
  private contractIdAndContractEnterpriseIdEncode: string = null;
  private customerId: number
  // toggle webcam on/off
  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public videoOptions: MediaTrackConstraints = {
    width: { ideal: 0 },
    height: { ideal: 0 }
  };
  public errors: WebcamInitError[] = [];
  private trigger: Subject<void> = new Subject<void>();
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();
  isNotAttestedUser: boolean = false;
  isVerifySubject: any;

  constructor(public customerFilter: CustomerFilterLanguage,
    public commonService: CommonService,
    private enterpriseService: EnterpriseService,
    public message: Message,
    private router: Router,
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private translateService: TranslateService,
    private authSer: AuthService,
    private kycService: KycService,
    public dialog: MatDialog,
    public deviceService: DeviceDetectorService,
    private toastr: ToastrService) {
    super(commonService, message);
    this.language = localStorage.getItem('__language') || 'vi';
    if (this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM) {
      this.isShowSidebarButton = false;
      this.zoomLevel = 50;
    }

    // Kiểm tra loại tài khoản KCT
    this.isNotAttestedUser = this.commonService.checkEnterpriseAnonymusType()
    if (this.isNotAttestedUser) this.checkAgree = true
  }

  ngOnInit() {
    this.route.paramMap.subscribe(params => {
      this.hashKey = params.get('hashKey');
      this.tenantId = params.get('tenantId');
      this.contractIdAndContractEnterpriseIdEncode = params.get('contractIdAndContractEnterpriseIdEncode') ? params.get('contractIdAndContractEnterpriseIdEncode') : null;
    });

    this.enterpriseId = localStorage.getItem('enterpriseId');

    this.commonService.getCategory().subscribe(result => {
      this.cities = result[0].data;
      this.districts = result[1].data;
      this.wards = result[2].data;
      this.getCustomer();
    })
    window.scrollTo(0, 0);

    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });
  }

  ngAfterViewInit() {
    setTimeout(_ => this.focus.first.nativeElement.focus());
  }


  getEnterpriseById(enterpriseId) {
    // this.enterpriseService.getEnterpriseByID(enterpriseId).subscribe(rs => {
    //   if (rs && rs.success) {
    //     this.enterpriseName = rs.data.name
    //   }
    // })
  }

  /**
   * Call api to get customer by id
   * @param id: number
   */
  loadPageAndChangerIsVerifySubject( isVerifySubject :any ){
    if (isVerifySubject == false) {
      const  url = localStorage.getItem(this.hashKey).replace('kyc-customer-identify', 'sign-anonymous');
      window.location.href = url;
    }
  }
  getCustomer() {
    const body = {
      hashKey: this.hashKey,
      tenantId: this.tenantId
    }
    this.customerService.getDetailCustomer(body).subscribe(
      rs => {
        if (rs == null || rs.data == null) {
          return 0;
        }
        // this.isVerifySubjectForLoad =rs.data.isVerifySubject
        this.loadPageAndChangerIsVerifySubject(rs.data.isVerifySubject)
        this.isVerifySubject= rs.data.isVerifySubject
        this.customer = {
          ...this.customer,
          ...rs.data,
          issuedDate: rs.data.issuedDate != null ? new Date(rs.data.issuedDate) : null,
          representativeIssuedDate: rs.data.representativeIssuedDate != null ? new Date(rs.data.representativeIssuedDate) : null,
          birthday: rs.data.birthday != null ? new Date(rs.data.birthday) : null,
          issuedDateDisplay: rs.data.issuedDate != null ? format(rs.data.issuedDate, 'DD/MM/YYYY'): null,
          representativeIssuedDateDisplay: rs.data.representativeIssuedDate != null ? format(rs.data.representativeIssuedDate, 'DD/MM/YYYY') : null,
          birthdayDisplay: rs.data.birthday != null ? format(rs.data.birthday, 'DD/MM/YYYY') : null
        };
        if (this.customer.attachmentImages && this.customer.attachmentImages.length == 3) {
          this.isEnoughImage = true
        }
        this.title = this.commonService.formatWithoutEscape(
          this.message.getMessage('kyc.note_inconrect_info'), this.customer.enterpriseName);
        this.getEnterpriseType();
        this.getEnterpriseById(this.customer.enterpriseId);

        // var cityItem = (this.customer.cityId != null) ? this.cities.find(x => x.id === this.customer.cityId) : undefined;
        // var districtItem = (this.customer.districtId != null) ? this.districts.find(x => x.id === this.customer.districtId) : undefined;
        // var wardItem = (this.customer.wardId != null) ? this.wards.find(x => x.id === this.customer.wardId) : undefined;
        this.addresses = {
          cityName: (this.customer.cityId != null) ? this.cities.find(x => x.id === this.customer.cityId).name : '',
          districtName: (this.customer.districtId != null) ? this.districts.find(x => x.id === this.customer.districtId).name : '',
          wardName: (this.customer.wardId != null) ? this.wards.find(x => x.id === this.customer.wardId).name : '',
        };
        this.getCertificateType();
        this.getRepresentativeCertificateType();
        this.viewDocumentUpload();
      }
    );
  }

  viewDocumentUpload() {
    const body = {
      hashKey: this.hashKey,
      tenantId: this.tenantId
    }
    this.kycService.verifyCustomerGetPdf(body).subscribe(res => {
      this.showPdf(res);
    });
  }

  showPdf(blob: any) {
    const file = this.blobToFile(blob, 'application/pdf');
    this.commonService.readFile(file, (pdfSrc) => {
      this.pdfSrc = pdfSrc;
    });
  }

  public blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    b.lastModifiedDate = new Date();
    b.name = fileName;

    // Cast to a File() type
    return theBlob as File;
  }

  /**
   * Get enterprise list
   */
  getEnterpriseType() {
    this.commonService.getEnterpriseType().subscribe(rs => {
      if (rs && rs.data) {
        this.enterpriseType = rs.data;
        this.customerType = this.enterpriseType.find(x => x.id === this.customer.customerType).langs;
      }
    });
  }

  /**
   * Get certificate list
   */
  getCertificateType() {
    this.commonService.getCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        this.certificateType = rs.data;
        if (this.customer.customerType !== this.personalId) {
          this.certificate = this.certificateType.find(x => x.id === this.customer.certificateId).langs;
        }
      }
    });
  }

  /**
   * Get representative certificate list
   */
  getRepresentativeCertificateType() {
    this.commonService.getRepresentativeCertificateType().subscribe(rs => {
      if (rs && rs.data) {
        this.representativeCertificateType = rs.data;
        if (this.customer.customerType === this.personalId) {
          this.representativeCertificate = this.representativeCertificateType.find(x => x.id === this.customer.certificateId);
        } else {
          this.representativeCertificate = this.representativeCertificateType.
            find(x => x.id === this.customer.representativeCertificateId);
        }
        this.representativeCertificateName = this.representativeCertificate !== undefined ? this.representativeCertificate.langs : '';
      }
    });
  }
  getEnterpriseTypeOptions(options) {
    const data = this.customerFilter.filterOptionsData(options);
    if (data !== undefined && data !== null) {
      return data;
    } else {
      return '';
    }
  }

  /**
   * Get cities list from local storage or api
   */
  loadCities() {
    // if (localStorage.getItem('cities') === null) {
    this.getCitiesRedis().subscribe(rs => {
      const data = rs.data;
      if (data != null && data.length > 0) {
        this.cities = data;
        localStorage.setItem(
          'cities',
          JSON.stringify(this.cities),
        );
      }
    });
    // } else {
    //   this.cities = JSON.parse(
    //     localStorage.getItem('cities')
    //   );
    // }
  }

  /**
   * Get districts list from local storage or api
   */
  loadDistricts() {
    // if (localStorage.getItem('districts') === null) {
    this.getDistrictsRedis().subscribe(rs => {
      const data = rs.data;
      if (data != null && data.length > 0) {
        this.districts = data;
        localStorage.setItem(
          'districts',
          JSON.stringify(this.districts),
        );
      }
    });
    // } else {
    //   this.districts = JSON.parse(
    //     localStorage.getItem('districts')
    //   );
    // }
  }

  /**
   * Get wards list from local storage or api
   */
  loadWards() {
    // if (localStorage.getItem('wards') === null) {
    this.getWardsRedis().subscribe(rs => {
      const data = rs.data;
      if (data != null && data.length > 0) {
        this.wards = data;
        localStorage.setItem(
          'wards',
          JSON.stringify(this.wards),
        );
      }
    });
    // } else {
    //   this.wards = JSON.parse(
    //     localStorage.getItem('wards')
    //   );
    // }
  }

  onBackClick() {
    let routeBack = 'identification-method'
    // Nếu là không chứng thực thì quay lại màn hình đăng nhập
    if (this.isNotAttestedUser) {
      routeBack = 'sign-anonymous'
    }
    if (this.contractIdAndContractEnterpriseIdEncode) {
      this.router.navigate([`${routeBack}/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}`]);
    } else {
      this.router.navigate([`${routeBack}/${this.hashKey}/${this.tenantId}`]);
    }
  }

  refuseIdentify() {
    this.dialog.open(RefuseIdentifyComponent, {
      width: '40%',
      data: {
        customerDTO: this.customer,
        hashKey: this.hashKey,
        tenantId: this.tenantId,
        hashLink: this.contractIdAndContractEnterpriseIdEncode
      }
    })
  }

  otpIdentify() {
    // kiểm tra dã bấm nút xác nhận chưa, nếu chưa thì đi tiếp
    if (this.isSubmitConfirm) return
    // Flag để check xem đã bấm nút xác nhận chưa
    this.isSubmitConfirm = true;
    const body = {
      hashKey: this.hashKey,
      tenantId: this.tenantId,
      phoneNumber: this.customer.phone
    }

    this.customerService.generateOtp(body).subscribe(rs => {
      if (rs && rs.success) {
        this.dialog.open(OtpIdentifyComponent, {
          width: '40%',
          data: {
            customerDTO: this.customer,
            hashKey: this.hashKey,
            tenantId: this.tenantId,
            otpTransactionId: rs.data,
            hashLink: this.contractIdAndContractEnterpriseIdEncode
          }
        })
        this.isSubmitConfirm = false;
      } else {
        this.toastr.error(rs.message);
        if (rs.code === ErrorCode.RefusedIdentify) {
          if (this.contractIdAndContractEnterpriseIdEncode) {
            this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}/detail`]);
          } else {
            this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/detail`]);
          }
        }
        this.isSubmitConfirm = false;
      }
      setTimeout(() => {
        // Bỏ flag
        this.isSubmitConfirm = false;
      }, 1000);
    })


  }

  verifyCheck() {
    console.log(this.customer);
    const dialogRef = this.dialog.open(VerifyEnterpriceDialogComponent, {
      width: this.deviceService.isMobile() ? '100%' : '56%',
      height: this.deviceService.isMobile() ? '80vh' : '',
      maxWidth: this.deviceService.isMobile() ? '90vw' : '80vw',
      panelClass: 'scontract-overlay-dialog',
      disableClose: true,
      data: {
        hashKey: this.hashKey,
        tenantId: this.tenantId,
        hashLink: this.contractIdAndContractEnterpriseIdEncode,
        signDataValidate: this.customer,
        enterpriseId: this.customer.enterpriseId
      }
    });
    dialogRef.afterClosed().subscribe(() => {
      // if (this.contractIdAndContractEnterpriseIdEncode) {
      //   this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/${this.contractIdAndContractEnterpriseIdEncode}/detail`]);
      // } else {
      //   this.router.navigate([`sign-anonymous/${this.hashKey}/${this.tenantId}/detail`]);
      // }
    });
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  public triggerSnapshot(): void {
    if (this.errors && this.errors[0] && this.errors[0].message) {
      // TODO show popup
    }
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
  }

  handleImage(webcamImage: WebcamImage): void {
    console.log('received webcam image', webcamImage);
  }

  hiddenCerrtificateNo(certificateNo: string){
    if(certificateNo){
      return certificateNo.includes('-null')
    } else {
      return false
    }
  }
}
